import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "I don't know coding at all. Will I struggle?",
    a: "No. Our AI-first approach is built for exactly you. 70% of our learners had zero coding background. You'll use AI prompts to generate your first Selenium script in week 1 — then slowly learn the logic behind it. You won't be thrown into Java from day one.",
  },
  {
    q: "I have 2–5 years of manual testing experience. Is this right for me?",
    a: "This is the perfect fit. We've optimized the curriculum for testers exactly in your experience range — because you already understand test cases, bugs, and SDLC. We just add the automation + AI layer on top, which means faster learning and immediate job-ready skills.",
  },
  {
    q: "Will this help me in a job switch?",
    a: "Yes. Every learner gets resume review, LinkedIn makeover, 3 real projects on GitHub, and mock interviews by Rahul himself. We also share job openings in our alumni group weekly. On average, our learners switch jobs within 45–90 days after completion.",
  },
  {
    q: "How is this different from Udemy / YouTube courses?",
    a: "YouTube gives you information overload with zero accountability. BYMAT gives you live coaching, weekly milestones, a mentor on WhatsApp, code reviews, and a structured path. You finish. That's the core difference.",
  },
  {
    q: "What if I can't attend a live session?",
    a: "All sessions are recorded and uploaded within 4 hours. You can catch up any time. Plus, weekly Q&A sessions ensure your doubts are never buried.",
  },
  {
    q: "Is there a refund policy?",
    a: "Yes. 7-day no-questions-asked refund on paid plans. Attend the first week, and if it's not for you, get 100% of your money back. No emails, no forms — just a WhatsApp message.",
  },
  {
    q: "Do I get a certificate?",
    a: "You get a BYMAT Automation + AI Testing Certificate on completion, plus 3 framework projects on your GitHub — which recruiters care about far more than certificates.",
  },
  {
    q: "What tools will I need?",
    a: "Just a laptop (8GB RAM, any OS) and stable internet. We'll help you set up IntelliJ, Maven, Git, and everything else during onboarding.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-20 md:py-32 px-6 md:px-10" data-testid="faq-section">
      <div className="max-w-4xl mx-auto">
        <div className="text-center">
          <div className="inline-block text-xs font-semibold tracking-[0.2em] uppercase text-[#38BDF8]">
            Still Thinking?
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-normal text-white mt-4 leading-tight">
            Your doubts, answered.
          </h2>
          <p className="mt-5 text-slate-400">
            The exact questions 90% of manual testers ask before enrolling.
          </p>
        </div>

        <Accordion type="single" collapsible className="mt-14 space-y-3" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-slate-900/60 border border-slate-800 rounded-2xl px-6 data-[state=open]:border-[#38BDF8]/40"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-display text-left text-base md:text-lg font-normal text-white hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
